"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseShiftCancellationDto = instanceOfNurseShiftCancellationDto;
exports.NurseShiftCancellationDtoFromJSON = NurseShiftCancellationDtoFromJSON;
exports.NurseShiftCancellationDtoFromJSONTyped = NurseShiftCancellationDtoFromJSONTyped;
exports.NurseShiftCancellationDtoToJSON = NurseShiftCancellationDtoToJSON;
exports.NurseShiftCancellationDtoToJSONTyped = NurseShiftCancellationDtoToJSONTyped;
const NurseShiftCancellationReason_1 = require("./NurseShiftCancellationReason");
/**
 * Check if a given object implements the NurseShiftCancellationDto interface.
 */
function instanceOfNurseShiftCancellationDto(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    return true;
}
function NurseShiftCancellationDtoFromJSON(json) {
    return NurseShiftCancellationDtoFromJSONTyped(json, false);
}
function NurseShiftCancellationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': (0, NurseShiftCancellationReason_1.NurseShiftCancellationReasonFromJSON)(json['reason']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
        'nurseProfileId': json['nurseProfileId'],
        'shiftId': json['shiftId'],
    };
}
function NurseShiftCancellationDtoToJSON(json) {
    return NurseShiftCancellationDtoToJSONTyped(json, false);
}
function NurseShiftCancellationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': (0, NurseShiftCancellationReason_1.NurseShiftCancellationReasonToJSON)(value['reason']),
        'comment': value['comment'],
        'createdAt': (value['createdAt'] == null ? null : value['createdAt'].toISOString()),
        'nurseProfileId': value['nurseProfileId'],
        'shiftId': value['shiftId'],
    };
}
//# sourceMappingURL=NurseShiftCancellationDto.js.map